import { z } from 'zod';
export const CommentaryFeedbackSchema = z.object({
    verseRef: z.string().min(1).optional(),
    originalQuery: z.string().optional(),
    reportMarkdown: z.string().min(1),
    commentaryText: z.string().optional(),
});
//# sourceMappingURL=commentary-feedback.js.map